/* eslint-disable unused-imports/no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
/**
 * Generated by orval v7.6.0 🍺
 * Do not edit manually.
 * Product Search API
 * Documentation of the controllers and endpoints used in the product-search-service.
 * OpenAPI spec version: deploy-only-CLOUDOPS-2882-2046
 */
import type {
  ListerDTO,
  SearchForProducts500,
  SearchForProductsParams,
  SearchForProductsServer500,
  SearchForProductsServerParams,
} from '@as-react/common-types/product-search-service';
import { useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { useCallback } from 'react';

import { queryFetch } from '../../utils/orval/queryFetch';
import { queryKeyMutator } from '../../utils/orval/queryKeyMutator';
import { useQueryFetch } from '../../utils/orval/useQueryFetch';
import type { ErrorType } from '../../utils/orval/useQueryFetch';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Search for products based on a search query
 */
export const useSearchForProductsHook = () => {
  const searchForProducts = useQueryFetch<ListerDTO>();

  return useCallback(
    (
      params: SearchForProductsParams,
      operationName = 'searchForProducts',
      options?: SecondParameter<ReturnType<typeof useQueryFetch>>,
      signal?: AbortSignal
    ) => {
      return searchForProducts(
        { url: `/api/aem/search`, method: 'GET', params, signal },
        { operationName: 'searchForProducts', ...options }
      );
    },
    [searchForProducts]
  );
};

export const useSearchForProductsQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useSearchForProductsHook>>>,
  TError = ErrorType<SearchForProducts500>,
>(
  params: SearchForProductsParams,
  operationName = 'searchForProducts',
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useSearchForProductsHook>>>, TError, TData>>;
    request?: SecondParameter<ReturnType<typeof useQueryFetch>>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryKeyMutator({ params, operationName }, { url: `/api/aem/search`, queryOptions });

  const searchForProducts = useSearchForProductsHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useSearchForProductsHook>>>> = ({ signal }) =>
    searchForProducts(params, operationName, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useSearchForProductsHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type SearchForProductsQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useSearchForProductsHook>>>
>;
export type SearchForProductsQueryError = ErrorType<SearchForProducts500>;

export function useSearchForProducts<
  TData = Awaited<ReturnType<ReturnType<typeof useSearchForProductsHook>>>,
  TError = ErrorType<SearchForProducts500>,
>(
  params: SearchForProductsParams,
  operationName: undefined | string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useSearchForProductsHook>>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useSearchForProductsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useSearchForProductsHook>>>
        >,
        'initialData'
      >;
    request?: SecondParameter<ReturnType<typeof useQueryFetch>>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useSearchForProducts<
  TData = Awaited<ReturnType<ReturnType<typeof useSearchForProductsHook>>>,
  TError = ErrorType<SearchForProducts500>,
>(
  params: SearchForProductsParams,
  operationName?: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useSearchForProductsHook>>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useSearchForProductsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useSearchForProductsHook>>>
        >,
        'initialData'
      >;
    request?: SecondParameter<ReturnType<typeof useQueryFetch>>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useSearchForProducts<
  TData = Awaited<ReturnType<ReturnType<typeof useSearchForProductsHook>>>,
  TError = ErrorType<SearchForProducts500>,
>(
  params: SearchForProductsParams,
  operationName?: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useSearchForProductsHook>>>, TError, TData>>;
    request?: SecondParameter<ReturnType<typeof useQueryFetch>>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Search for products based on a search query
 */

export function useSearchForProducts<
  TData = Awaited<ReturnType<ReturnType<typeof useSearchForProductsHook>>>,
  TError = ErrorType<SearchForProducts500>,
>(
  params: SearchForProductsParams,
  operationName = 'searchForProducts',
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useSearchForProductsHook>>>, TError, TData>>;
    request?: SecondParameter<ReturnType<typeof useQueryFetch>>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useSearchForProductsQueryOptions(params, operationName, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Search for products based on a search query
 */
export const searchForProductsServer = (
  params: SearchForProductsServerParams,
  operationName = 'searchForProducts',
  options?: SecondParameter<typeof queryFetch>,
  signal?: AbortSignal
) => {
  return queryFetch<ListerDTO>(
    { url: `/aem/search`, method: 'GET', params, signal },
    { operationName: 'searchForProducts', ...options }
  );
};

export const useSearchForProductsServerQueryOptions = <
  TData = Awaited<ReturnType<typeof searchForProductsServer>>,
  TError = ErrorType<SearchForProductsServer500>,
>(
  params: SearchForProductsServerParams,
  operationName = 'searchForProducts',
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof searchForProductsServer>>, TError, TData>>;
    request?: SecondParameter<typeof queryFetch>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryKeyMutator({ params, operationName }, { url: `/aem/search`, queryOptions });

  const queryFn: QueryFunction<Awaited<ReturnType<typeof searchForProductsServer>>> = ({ signal }) =>
    searchForProductsServer(params, operationName, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof searchForProductsServer>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type SearchForProductsServerQueryResult = NonNullable<Awaited<ReturnType<typeof searchForProductsServer>>>;
export type SearchForProductsServerQueryError = ErrorType<SearchForProductsServer500>;

export function useSearchForProductsServer<
  TData = Awaited<ReturnType<typeof searchForProductsServer>>,
  TError = ErrorType<SearchForProductsServer500>,
>(
  params: SearchForProductsServerParams,
  operationName: undefined | string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof searchForProductsServer>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchForProductsServer>>,
          TError,
          Awaited<ReturnType<typeof searchForProductsServer>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof queryFetch>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useSearchForProductsServer<
  TData = Awaited<ReturnType<typeof searchForProductsServer>>,
  TError = ErrorType<SearchForProductsServer500>,
>(
  params: SearchForProductsServerParams,
  operationName?: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof searchForProductsServer>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchForProductsServer>>,
          TError,
          Awaited<ReturnType<typeof searchForProductsServer>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof queryFetch>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useSearchForProductsServer<
  TData = Awaited<ReturnType<typeof searchForProductsServer>>,
  TError = ErrorType<SearchForProductsServer500>,
>(
  params: SearchForProductsServerParams,
  operationName?: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof searchForProductsServer>>, TError, TData>>;
    request?: SecondParameter<typeof queryFetch>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Search for products based on a search query
 */

export function useSearchForProductsServer<
  TData = Awaited<ReturnType<typeof searchForProductsServer>>,
  TError = ErrorType<SearchForProductsServer500>,
>(
  params: SearchForProductsServerParams,
  operationName = 'searchForProducts',
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof searchForProductsServer>>, TError, TData>>;
    request?: SecondParameter<typeof queryFetch>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useSearchForProductsServerQueryOptions(params, operationName, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
